<template>
	<div>
		<!-- 支付弹框 -->
		<pay-modal :payPrice="orderList[count].order_total_price" v-if="isPayModal" :showClose="true"
			@close-modal="onCloseModalClick" @payClick='payClick' @goToCharge="goToCharge">
		</pay-modal>
		
		<!-- 钱包余额不足弹框 -->
		<confirm-modal v-if="noEnough" :isEnough="true" :firmTitle="firmTitle_1" :firmLeft="firmLeft_1" :firmRight="firmRight_1"
			@leftClick="onCloseModalClick" @rightClick="goToCharge">
		</confirm-modal>
		
		<!-- 是否取消订单 -->
		<confirm-modal v-if="isCancel" :noWidth="true" :firmTitle="firmTitle" :firmLeft="firmLeft" :firmRight="firmRight"
			@leftClick="operateOrder(1)" @rightClick="onCloseModalClick">
		</confirm-modal>
		
		<!-- 是否完成订单 -->
		<confirm-modal v-if="isSubmit" :firmTitle="firmTitle_2" :firmLeft="firmLeft_2" :firmRight="firmRight_2"
			@leftClick="onCloseModalClick" @rightClick="operateOrder(2)">
		</confirm-modal>
		
		<!-- 驳回订单 -->
		<common-reject v-if="isReject" @clickReject="clickReject" @close-modal="onCloseModalClick"></common-reject>

		<!-- 新撤单,退款弹框-->
		<common-tips v-if="isShowTips" :tipObj="tipObj" @showAgreeMent="isAgreeMent=true" @submitFun="submitFun" @close-modal="onCloseModalClick"></common-tips>
		
		<!-- 下单协议弹框 -->
		<show-agree-ment v-if="isAgreeMent" @close-modal="onCloseModalAgree"></show-agree-ment>
		
		<!-- 订单取消成功弹框 -->
		<toast-modal :isToast="isToast" :ToastText="ToastText"></toast-modal>
		
		<qr-code-url v-if="qrcodeUrl" :qrcodeUrl="qrcodeUrl" tips="支付" :chargeMoney="chargeMoney" @deletePay="onCloseModalClick"></qr-code-url>
		
		<common-modal v-if="isShowModal" :showClose="true" @close-modal="onCloseModalClick">
			<div class="modal">
				<div class="order-detail order-content">
					<div class="title">保障计划</div>
					<div class="agree-text">
					   <p>1、订单处理周期为五天，超过处理时间，商家可以直接申请全额退还款项，系统审核后款项原路退回。</p>
					   <p>2、订单处理期间，订单状态为“处理中”，表示订单正在处理，商家无故中途撤单，按<span style="color: #4184F4;" @click="isAgreeMent=true">《用心淘下单协议》</span>只能退还50%支付款项，系统审核后款项原路退回。</p>
					   <p>3、订单处理期间，订单状态变更为“未解决”，表示订单未处理成功， 商家可以直接申请全额退款，系统审核后款项原路退回。</p> 
					</div>
				</div>
			</div>
		</common-modal>
		
		<div :style="{ height: wrapperHeight + 'px' }" class="list">
			<!-- 搜索栏 -->
			<div class="fixed-wrap">
				<div class="search-wrap">
					<form action="#" onsubmit="return false" class="search-content">
					  <input id="searchInput" ref="input1" type="search" v-model.trim="keyword" @keyup.13='search' placeholder="请输入订单编号/买家旺旺查找">
					</form> 
				</div>
				
				<div class="tabs myorder-tab">
					<p class="tab-btn" v-for="(item,index) in tabs" :key='index' :class='tabCur==item.status?"btn-active":""' @click="changeTabs(item)">
						<span>{{item.name}}</span>
						<span v-if="item.status==2 && isShowUnRead" class="unpay-num"></span>
					</p>
				</div>
			</div>
			
			<mt-loadmore  v-if="orderList && orderList.length" :bottom-method="loadBottom" :auto-fill="false" :bottom-all-loaded="allLoaded" ref="loadmore" :bottomPullText='"加载更多"' :bottomLoadingText='"加载中"' :bottomDropText='"释放加载"'>
				<div class="page-con">
					<div class="c_item" v-for="(item,index) in orderList" :key="index" @click="goToDetail(item)">
						<div class="i_part1">
							<div class="c_item_img">
								<img :src="imgUrl+item.server_info.server_icon" alt="">
								<p class="title-c">{{item.server_info.server_name}}</p>
								<p class="status-c" :class='item.order_status==1 || item.order_status==10 || item.order_status==11?"co-status":""'>{{item.statusName}}</p>
							</div>
							
							<div class="c_item_info">
								<img src="@/assets/images/order-manage/ic_order_2.png" alt="">
								<span class="order-num">{{item.order_code}}</span>
								<div class="copy" @click.stop="utils.copyText(item.order_code)">复制</div>
								<img v-if='item.server_type==1' src="@/assets/images/order-manage/ic_order_1.png" alt="" class="wang-wang">
								<span v-if='item.server_type==1' class="name">{{item.merchant_wangwang}}</span>
							</div>
						</div>
						
						<div class="i_part2">
							<p class="p_count">合计：<span class="i_money">¥{{item.order_total_price}}</span></p>
							<!-- 已驳回，退款，取消，处理钟不展示 1待支付 2待处理 3 处理中 4待确认 5已完成 6已撤单 7 取消订单 8 已驳回 9已退款 10退款中 11未解决 -->
							
							<!-- 1.待支付 -->
							<p class="p_btns" v-if="item.order_status==1">  
								<span class="acDo_btn_2" @click.stop="payMent(index)">付款</span>
							</p> 
							
							<!-- 3.处理中 -->
							<p class="p_btns" v-if="item.order_status==3 || item.order_status==13">
								<span class="acDo_btn_2" @click.stop="refund(index)" v-if="item.isOverFive">退款</span>
								<span class="acDo_btn_3" @click.stop="isShowModal=true" v-else>退款</span> 
							</p> 
							
							<!-- 4待确认 -->
							<p class="p_btns" v-if="item.order_status==4">
								<span class="cancel_btn no-m" @click.stop="reject(index)">驳回</span>   
								<span class="acDo_btn_2" @click.stop="submit(index)">完成</span>
							</p> 
							
							<!-- 5已完成 -->
							<p class="p_btns" v-if="item.order_status==5">
								<span v-if="item.is_comment==1" @click.stop="comment(index)">吐槽</span>
								<span class="acDo_btn_3" v-if="item.is_comment==2" @click.stop="">已吐槽</span>
							</p> 
							
							<!-- 8 已驳回 -->
							<p class="p_btns" v-if="item.order_status==8">
								<span class="acDo_btn_2" @click.stop="submit(index)">完成</span>
							</p> 
							
							<!-- 9已退款 10退款中 11未解决 -->
							<p class="p_btns" v-if="item.order_status==9 || item.order_status==10 || item.order_status==11">
								<span class="acDo_btn_3" @click.stop="refund(index)" v-if="item.order_status==9">退款</span>
								<span @click.stop="refund(index)" v-else-if="item.order_status==10">退款</span>
								<span class="acDo_btn_2" @click.stop="refund(index)" v-else>退款</span>
              </p>

              <p class="p_btns" v-if="['4','5','8','9','10','11','7'].includes(item.order_status)">
                <span class="acDo_btn_3"  @click.stop="delOrder(item)">删除</span>
              </p>
						</div>
					</div>
				
				</div>
			</mt-loadmore>
			<div v-else>
				<div class="no-order">
					<img src="../assets/images/no-order.png">
                    <p>暂无订单</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import utils from '@/assets/jslibs/utils'
import {getOrderList,operateOrder,getOrderPay,getOrderDetail,delOrders} from '@/api/order'
import ToastModal from '@/components/ToastModal'
import ConfirmModal from '@/components/ConfirmModal'
import CommonHeader from '@/components/CommonHeader'
import PayModal from '@/components/PayModal'
import QrCodeUrl from '@/components/QrCodeUrl'
import CommonModal from '@/components/CommonModal'
import CommonTips from '@/components/CommonTips'
import ShowAgreeMent from '@/components/ShowAgreeMent'
import CommonReject from '@/components/CommonReject'
import wx from "weixin-js-sdk";
export default {
    name : 'myOrder',
    data(){
        return {
			utils,
			tipObj:{
				title:"",
				content:"",
				num:null
			},
			isShowModal:false,
			isReject:false,				//是否展示驳回订单弹框
			isAgreeMent:false,			//是否显示协议弹框
			isShowTips:false,			//是否显示撤单弹框
			wrapperHeight:0,
			allLoaded:false,
			imgUrl:this.$store.state.imgUrl || sessionStorage.getItem("imgUrl"),
            isSubmit:false,        //确认完成弹窗
            noEnough:false,       //钱包余额不足弹框
            isPayModal:false,     //支付弹框
            ToastText:"",       //驳回，催单，取消成功提示语
            isToast:false,      
            isCancel:false,     //是否取消订单弹窗
            firmTitle:"是否取消当前订单",
            firmLeft:"是",
            firmRight:"否",
            
            firmTitle_1:"钱包余额不足 该充值啦",
            firmLeft_1:"返回",
            firmRight_1:"充值",
            
            firmTitle_2:"是否确认完成当前订单",
            firmLeft_2:"取消",
            firmRight_2:"确定",
            count:"",           //记录用户当前操作订单的下标
			tabCur:1,
			tabs:[{name:"全部",status:1},{"name":"处理中",status:3},{"name":"待付款",status:2},{"name":"未解决",status:5},{"name":"已成功",status:4}],
            orderList:[],
			order_uuid:"",
			qrcodeUrl : '',
			chargeMoney:"",        //支付金额
			timer:null,
			searchTimer:null,	//搜索截流
			isMobile : utils.isMobile(),
            payStyle:1,                //选择支付的方式
            page_index: 1,
            page_size: 25,
			clickPay:true,            //是否可以点击支付
			keyword:"",					//搜索关键字
			isShowUnRead:false
        }
    },
	
	beforeCreate(){
		sessionStorage.setItem("roleType","customer")
	},
    
    created(){
		this.getOrderList("1");
		clearTimeout(this.timer);
    },
	
	mounted(){
	    this.wrapperHeight = document.documentElement.clientHeight;
        document.title = "我的订单"
		window.addEventListener('touchmove', (event)=>{ 
		    if(this.isSubmit || this.isCancel || this.isReject ||
			this.isPayModal ||this.noEnough || this.isShowTips || this.isAgreeMent){
		        event.preventDefault(); 
		    }
		}) 
		
		window.addEventListener('pageshow',()=>{
		    if(sessionStorage.getItem("havePay") && sessionStorage.getItem("payId")) {
		        this.order_uuid = sessionStorage.getItem("payId");      //取成功支付之后的订单号
		        this.getPayStatus();
		    }
		})
	},

    methods:{
        async getOrderList(type){
			if(this.isMobile==2){//pc端展示所有的
				this.page_size = 999;
			}
            let obj={status:type,keyword_search:this.keyword,page_index:this.page_index,page_size:this.page_size};
			const { data, status } = await getOrderList(obj);
            if (status !== 200) return 
            this.orderList = data.data
			if(data.data.length){
			    this.page_index += 1;
			}
			this.orderList.forEach((item,index)=>{
				item.statusName = utils.statusToName(item.order_status);
				if(item.statusName == "已撤单" || item.statusName == "待处理" || item.statusName == "已撤回"){
					item.statusName = "处理中"
				}
                item.clickPay = true;    //是否支付的标示
				let createTime = new Date(item.pay_time).getTime();					//支付时间
				let noweTime = new Date().getTime();								//当前时间
				let fiveDayTime = 5*24*60*60*1000;
				if(noweTime - createTime >fiveDayTime){//超过5天
					this.$set(item,"isOverFive", true);
				}else{
					this.$set(item,"isOverFive", false);
				}
				if(item.order_status == "1"){//如果有待支付订单,则显示未读标记
					this.isShowUnRead = true
				}
			})
        },
		
		loadBottom(){
		    this.$refs.loadmore.onBottomLoaded();
		    this.$refs.loadmore.onTopLoaded();
		    this.loadMore()
		},
		
		async loadMore(){
			let obj={status:this.tabCur,keyword_search:this.keyword,page_index:this.page_index,page_size:this.page_size};
		    const { data, status } = await getOrderList(obj);
		    if( status !== 200) return
		    if(data.data.length){
		        this.page_index += 1
		        this.orderList = this.orderList.concat(data.data);
				this.orderList.forEach((item,index)=>{
					item.statusName = utils.statusToName(item.order_status);
					if(item.statusName == "已撤单" || item.statusName == "待处理"){
						item.statusName == "处理中"
					}
                    item.clickPay = true;    //是否支付的标示
					let createTime = new Date(item.pay_time).getTime();					//支付时间
					let noweTime = new Date().getTime();								//当前时间
					let fiveDayTime = 5*24*60*60*1000;	
					if(noweTime - createTime >fiveDayTime){//超过5天
						this.$set(item,"isOverFive", true);
					}else{
						this.$set(item,"isOverFive", false);
					}
					if(item.order_status == "1"){//如果有待支付订单,则显示未读标记
						this.isShowUnRead = true
					}
				})
		    }else{
		        window.toast("没有更多数据","txt");
		    }
		},

      //删除订单
      delOrder(item){
        //confirm('确实要删除该内容吗?','HHHH')

        this.$createDialog({
          type: 'confirm',
          icon: '',
          title: '确认删除订单？',
         /* content: '删除后可找管理员恢复',*/
          confirmBtn: {
            text: '取消',
            active: true,
            disabled: false,
            href: 'javascript:;'
          },
          cancelBtn: {
            text: '确认',
            active: false,
            disabled: false,
            href: 'javascript:;'
          },
          onConfirm: () => {
            //取消按钮
          },
          onCancel: () => {
            delOrders(item.uuid);
            this.$createToast({
              type: 'correct',
              time: 1000,
              txt: '删除成功'
            }).show()
            this.page_index = 1;
            this.getOrderList(this.tabCur);
          }
        }).show()
      },

        // 取消订单
        cancel(index){
            this.isCancel = true;
            this.count = index;
            this.order_uuid = this.orderList[index].uuid;
        },
        
        // 立即支付
        payMent(index){
            this.isPayModal = true;
            this.count = index;
            this.order_uuid = this.orderList[index].uuid;
            this.clickPay = this.orderList[index].clickPay;
			this.chargeMoney = this.orderList[index].order_total_price;
        },
		
		//撤单
		rescind(index){
			this.tipObj = {
				title:"您确定要撤单么？",
				content:'您的订单在五天处理期限内，现在撤单，根据<span id="agree" style="color: #4184F4;">《下单协议》</span>须扣除订单金额50%违约金哦，您确定么？',
				num:1
			}
			this.isShowTips = true;
			this.count = index;
			this.order_uuid = this.orderList[index].uuid;
		},
		
		//退款
		refund(index){
			this.count = index;
			this.order_uuid = this.orderList[index].uuid;
			if(this.orderList[index].order_status == 3 || this.orderList[index].order_status == 11){//点击处理中显示的退款按钮,未解决中的退款
				this.tipObj = {
					title:"确定要申请退款么？",
					content:'申请退款后，款项48小时内原路退回。',
					num:2
				}
				this.isShowTips = true;
			}else{
				let backurl = location.href;
				this.$router.push({path:'./refund-detail',query:{order_uuid:this.order_uuid,backurl:backurl,refund:"user"}})
			}
		},
		
		//驳回订单
		reject(index){
			this.isReject = true;
			this.count = index;
			this.order_uuid = this.orderList[index].uuid;
		},
		
        //确认完成订单
        submit(index){
            this.isSubmit = true;
            this.count = index;
            this.order_uuid = this.orderList[index].uuid;
        },
		
		//确认撤销订单和退款
		submitFun(num){
			this.operateOrder("5");
			this.isShowTips = false;
		},
		
		//确认驳回订单
		clickReject(selectFlag,otherReason){
			let reason_for_rejection="";
			if(selectFlag==0){
				reason_for_rejection = "未解决问题"
			}else if(selectFlag==1){
				if(!otherReason){
					window.toast("请输入驳回理由","txt");
					return
				}
				if(otherReason.length>100){
					window.toast("驳回理由不得超过100字","txt");
					return
				}
				reason_for_rejection = otherReason
			}
			this.operateOrder(3,reason_for_rejection)
		},
        
        //立即评价
        comment(index){
            this.count = index;
            this.order_uuid = this.orderList[index].uuid;
            this.$router.push({path:'./assess',
                query:{
                    order_uuid:this.order_uuid,
                    server_icon:this.orderList[index].server_info.server_icon,
                    server_name:this.orderList[index].server_info.server_name,
                    url:location.href
                }
            });
        },
        
        // 操作订单
        async operateOrder(type,reason_for_rejection){
        	let parmas ={type:type,reason_for_rejection:reason_for_rejection}
        	const { data, status } = await operateOrder(this.order_uuid,parmas);
        	if (status !== 200) return 
            if(type==2){//确认完成订单
                this.isSubmit = false
                this.$router.push({path:'./operate-success',query:{order_uuid:this.order_uuid,flag:"success",role:"user"}})
            }
            
            else if(type==1){//确认取消订单
                this.isCancel = false;
                this.ToastText = "订单已成功取消";
                this.isToast = true;
				this.page_index = 1;				
                this.getOrderList(this.tabCur);     //取消成功，更新状态，从第一开始查询
            }
			else if(type==3){//确认驳回订单
				this.isReject = false
				this.ToastText = "订单申请驳回成功 请等待管理员处理";
				this.isToast = true;
				this.page_index = 1;				
				this.getOrderList(this.tabCur);     //驳回成功，更新状态，从第一开始查询
			}
			else if(type==5){//退款
				let backurl = location.href;
				this.$router.push({path:'./refund-detail',query:{order_uuid:this.order_uuid,backurl:backurl,refund:"user"}})
			}
			
        },
        
        //确认支付
        async payClick(payStyle){
			this.payStyle = payStyle;
			if(!this.clickPay) {
				window.toast("请勿重复点击","txt");
				return;
			}
			this.clickPay = false;
			
			setTimeout(()=>{
				this.clickPay = true;
			},3000)
			
			let obj ={type:this.payStyle,order_uuid:this.order_uuid};
      let web_obj = {type:this.payStyle,order_uuid:this.order_uuid};
			if(this.isMobile==1){
				obj.order_tag = 1
        web_obj.order_tag = 1;
			}else if(this.isMobile==2){
				obj.order_tag = 2
        web_obj.order_tag = 2;
			}else if(this.isMobile==3){
				obj.order_tag = 3
        web_obj.order_tag = 3;
			}

          //判断一下是不是在小程序中
          wx.miniProgram.getEnv(function (res) {
            if (res.miniprogram) {
              // 小程序环境下逻辑
              console.log("小程序环境,需要调用小程序支付");
              //obj.order_tag = 3;
              web_obj.order_tag = 4;
              obj.wx_type   = 'minApp' //小程序
            }
          });

			const { data, status } = await getOrderPay(obj);
			this.isPayModal = false
			if(status==200){
				if(this.payStyle=="2"){//钱包支付
					this.$router.push({path:"./pay-success",query: {order_uuid:data.order_uuid,totalPrice:this.orderList[this.count].order_total_price}});
				}
				else{//微信支付
					if(web_obj.order_tag == 2){//扫码支付
						this.isPayModal = false;
						this.qrcodeUrl = data.code_url;							
					}else if(web_obj.order_tag == 1){//h5支付
						sessionStorage.setItem("havePay","havePay");
						sessionStorage.setItem("payId",data.order_uuid);
						location.href = data.mweb_url;
					}else if(web_obj.order_tag == 3){//微信公众号支付
						this.order_uuid = data.order_uuid;
						let timeStamp = String(data.timeStamp);
						this.pay("wxf3c9d00e530fedd8",timeStamp,data.nonceStr,data.package,data.signType,data.paySign);
					}else if (web_obj.order_tag == 4){
            //小程序支付
            //this.AWechatJsPay();
            data.timeStamp = String(data.timeStamp);

            const payParamsStr = encodeURIComponent(JSON.stringify(data));
            const url=`../wxpay/wxpay?payParamsStr=${payParamsStr}`;
            wx.miniProgram.navigateTo({url:url});
            console.log('跳到小程序支付页面中去')
          }
					
					this.order_uuid = data.order_uuid;
					this.getPayStatus()
				}	
			}else{
				if(data.error.message == "余额不足" && this.payStyle=="2"){
					this.noEnough = true;
				}
			} 
        },
        
        // 调微信支付
        pay(appId,timeStamp,nonceStr,packages,signType,paySign){  
        	let self = this;
            if (typeof WeixinJSBridge == "undefined"){  
               if( document.addEventListener ){  
                   document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);  
               }else if (document.attachEvent){  
                   document.attachEvent('WeixinJSBridgeReady', onBridgeReady);   
                   document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);  
               }  
            }else{  
               self.onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign);  
            }   
        },  
        
        //唤醒微信支付
        onBridgeReady(appId,timeStamp,nonceStr,packages,signType,paySign){
            let self = this;
        	WeixinJSBridge.invoke(
        		'getBrandWCPayRequest',
        		{
        			"appId":"wxf3c9d00e530fedd8",     //公众号名称，由商户传入     
        			"timeStamp":timeStamp,         //时间戳，自1970年以来的秒数     
        			"nonceStr":nonceStr, //随机串     
        			"package":packages,     
        			"signType":signType,         //微信签名方式：     
        			"paySign":paySign //微信签名 
        		},
        		
        		function(res){
        			if(res.err_msg == "get_brand_wcpay_request:ok"){// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
						self.$router.push({path:"./pay-success",query: {order_uuid:self.order_uuid,totalPrice:self.orderList[self.count].order_total_price}});
        			}else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
                        window.toast("支付失败","txt");
        			}else if (res.err_msg === 'get_brand_wcpay_request:fail') {
                        window.toast("支付失败","txt");
        			}
        		}
        	)
        },
		
		// 轮询正常订单支付状态
		async getPayStatus(){
            sessionStorage.removeItem("havePay");
            sessionStorage.removeItem("payId");
			clearTimeout(this.timer);
			const { data, status } = await getOrderDetail(this.order_uuid);
			if( status == 200 && data.is_pay == 2){
				clearTimeout(this.timer);
				this.qrcodeUrl = false;
                this.isPayModal = false;
				
				this.$router.push({path:"./pay-success",query: {order_uuid:this.order_uuid,totalPrice:this.orderList[this.count].order_total_price}});
			}else{
				clearTimeout(this.timer);
				this.timer = setTimeout(()=>{
					this.getPayStatus()
				},2000)
			}
		},
		
        // 取消或者关闭弹框
        onCloseModalClick(){
            this.isCancel = false;
            this.isPayModal = false;
            this.noEnough = false;      //取消充值
            this.isSubmit = false;      //确认完成
			this.qrcodeUrl = false;
			this.isShowTips = false;		//关闭撤单弹框
			// this.isAgreeMent = false;	//关闭协议弹框
			this.isReject = false;		//关闭驳回订单弹框
			this.isShowModal = false;
			clearTimeout(this.timer);
        },
		
		//关闭协议
		onCloseModalAgree(){
			this.isAgreeMent = false;	//关闭协议弹框
		},
        
        // 去充值
        goToCharge(){
        	this.noEnough = false;
        	this.$router.push({path:"./recharge",query: {url:location.href}})
        },

		changeTabs(item){
			this.orderList =[];
			this.tabCur = item.status;
			this.page_index = 1;		//切换查询都是从第一页开始查
			this.getOrderList(this.tabCur)
		},
        
		goToDetail(item){
			 this.$router.push({path:'./order-detail',query:{order_uuid:item.uuid}})
		},
		
		backHeight(){
		    setTimeout(() => {
		        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
		        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
		    }, 100);
		},
		
		clearTimer() {
			if (this.searchTimer) {
			  clearTimeout(this.searchTimer);
			}
		},
		
		search(){
			this.$refs.input1.blur();
			this.getOrderList(1);
		}
    },
	
	watch:{
		keyword(){
			this.clearTimer();
	        this.searchTimer = setTimeout(()=>{
	            this.page_index =1;
	            this.getOrderList("1")
	        },500)
			if(!this.keyword){
				this.$refs.input1.blur();
			}
		}
	},
    
    components : {
       CommonHeader,
       ConfirmModal,
       ToastModal,
       PayModal,
       CommonModal,
	   QrCodeUrl,
	   CommonTips,
	   ShowAgreeMent,
	   CommonReject
    }
}
</script>
<style lang='less' scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	.no-order{width:56px;height:82.5px;margin: 0 auto;margin-top:50%;margin-bottom:50%}
	.no-order img{width: 100%;height: 100%}
	.no-order p{text-align: center;font-size:13px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(207,207,207,1);line-height:18.5px;margin-top: 10.5px}
	.list{overflow-y: scroll; width: 100%;height: 100%;padding-bottom: 50px;-webkit-overflow-scrolling: touch; background: #f5f5f5;};
    body{width:100%;height:100%;background:#F5F5F5;font-family:PingFangSC-Regular;font-weight:400;}
    .tabs{width:100%;.h(44);display:flex;background:#fff;z-index: 9}
    .tab-btn{flex:1;.l-h(44);text-align:center; .f-s(14);font-family:PingFangSC-Medium;font-weight:500;position: relative}
    .tab-btn span{display:inline-block;.h(43);.l-h(43);}
	.tab-btn .unpay-num{display: inline-table;position: absolute;width: 7px;height: 7px;border: none;background: rgba(255,134,48,1);border-radius: 50%;top: 26%;right: 10%;}
    .btn-active span{color:#4184F4;border-bottom:1px solid #4184F4;}
    .page-con{padding:10px; background:#f5f5f5;}
    .c_item{padding:10px 15px 0 14px;  background:#fff;margin-bottom:10px;}
    .i_part1{border-bottom:1px solid #f5f5f5;}
    .i_part1 .c_item_img{display:flex;align-items: center;}
	.i_part1 .c_item_img img{height: 21px;width: 21px;margin-right: 9px;}
	.i_part1 .c_item_img .title-c{font-weight:bold;color: rgba(51,51,51,1);font-size: 15px;}
	.i_part1 .c_item_img .status-c{font-weight: bold;color: rgba(65,132,244,1);font-size: 13px;width: 1.6rem; text-align: right;flex: 1;}
    .i_part1 .c_item_img .co-status{color:rgba(255,134,48,1);}
	
	.i_part1 .c_item_info{display: flex;align-items: center;padding: 18px 0;}
    .c_item_info img{width: 15px;height: 15px;}
	.c_item_info .order-num{font-size: 14px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);margin: 0 5px 0 9px;}
	.c_item_info .copy{font-size: 12px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);padding: 1px 5px;border-radius: 1px; border: 1px solid rgba(193,193,193,1);}
	.c_item_info .wang-wang{margin: 0 4px 0 32px}
	.c_item_info .name{overflow: hidden;white-space: nowrap;text-overflow: ellipsis;/*width: 120px;*/font-size: 14px;font-family: PingFangSC-Regular,PingFang SC;font-weight: 400;color: rgba(174,174,174,1);}


    .i_part1 .c_item_state{.w(60);line-height:0.6rem; text-align:right; .f-s(13); color:#333;}
    .i_part1 .state_sp{color:rgba(65,132,244,1);}
    .i_part2{.h(50);}
    .p_count{float:left;.l-h(50); .f-s(13); color:rgba(51,51,51,1);}
    .p_count .i_money{ .f-s(14);color:rgba(51,51,51,1); }
    .p_btns{float:right;.l-h(50)}
    .p_btns span{display:inline-block; .h(30); .w(65);text-align:center; .l-h(28); color:#999; border:1px solid #999;margin:0 0.2rem;border-radius:2px;font-size: 13px}
    .p_btns .acDo_btn_1{border-color:#4184F4; color:#4184F4;}
    .p_btns .acDo_btn_2{background:#4184F4;border-color:#4184F4;color:#fff;}
    .p_btns .acDo_btn_3{background:#f5f5f5;color:#999;border-color:#f5f5f5;}
    .p_btns .no-m{margin: 0}
	
    /* 追加订单费用 */
    .modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
    .title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
    .cost{margin-bottom: 10px;font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);}
    .cost-wrap{padding-left: 23px;padding-top: 20px}
    .cost-num{width:278px;height:40px;padding-left: 22px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(151,151,151,1);font-family:PingFangSC-Regular;font-size:13px;font-weight:400;color:rgba(153,153,153,1);}
    .un-boder{border: none;justify-content: space-between;}
    .modal-submit{width:278px;height:40px;margin: 0 auto;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}
    .submit-mt{margin-top: 110px}
	
	/* 搜索栏 */
	.fixed-wrap{position: -webkit-sticky;position: sticky;top: 0;left: 0;right: 0;width: 100%;}
	.search-wrap{width:100%;height:57.5px;display: flex;align-items: center;justify-content: center;background:rgba(255,255,255,1);border-bottom: 1px solid #E5E5E5;}
	.search-content{width:345px;height:37.5px;background:rgba(245,245,245,1);border-radius:3px;}
	.search-content input{height: 100%;width: 100%;box-sizing: border-box; padding-left: 37px;background:#f5f5f5 url("../assets/images/order-manage/ic_search.png") no-repeat 9px center;background-size: 18px;}
	
	/* 保障计划 */
	.agree-text{padding: 20px 14px 10px 14px}
	.agree-text p{font-size:14px;margin-bottom: 15px;line-height: 22px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);letter-spacing:1px;}
</style>    